export default `

octets-per-line: 2
x-axis:
  octets:
    direction: left-to-right
    origin: 0

y-axis:
  octets:
    show: true

placements:
- label: Hardware type (HTYPE)
  bits: 16
- label: Protocol type (PTYPE)
  bits: 16
- label: Hardware address length (HLEN)
  bits: 8
- label: Protocol address length (PLEN)
  bits: 8
- label: Operation (OPER)
  bits: 16
- label: Sender hardware address (SHA)
  bits: 48
  fill: "#f0fff0"
- label: Sender protocol address (SPA)
  bits: 32
  fill: "#d0ffd0"
- label: Target hardware address (THA)
  bits: 48
  fill: "#f0f0ff"
- label: Target protocol address (TPA)
  bits: 32
  fill: "#d0d0ff"
`;
